// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, number, string } from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { fetchWrapper } from 'helpers/api'
import triggerFileDownload from 'helpers/triggerFileDownload'

import {
  error,
  hide,
  warning,
} from 'react-notification-system-redux'

class GeneratingMessage extends React.Component {
  static propTypes = {
    exportJobId: number.isRequired,
    hide: func.isRequired,
    uid: string.isRequired,
    warning: func.isRequired,
  }

  state = {
    jobStatus: null,
  }

  componentDidMount () {
    this.setState((s, { jobStatus }) => ({ jobStatus }))
    this.__intervalId = setInterval(this.checkJobStatus, 3000)
  }

  componentWillUnmount () {
    // just in case
    clearInterval(this.__intervalId)
  }

  __intervalId = null

  checkJobStatus = async () => {
    const { hideMessage } = this
    const {
      error,
      exportJobId,
      uid,
    } = this.props

    try {
      const { entity } = await fetchWrapper(`/pathExport/${exportJobId}`)

      const {
        jobStatus,
        fileUrl,
        message,
      } = entity

      // if something happened when trying to generate the report,
      // tell em!
      if (jobStatus === 'Error') {
        throw new Error(`Error: ${message}`)
      }

      // if the message is a warning, then display the warning to the user in the UI
      if (message.indexOf('Warning') === 0) {
        this.displayWarning(message)
      }

      // if the file was successfully generated and stored, go get that file!
      if (fileUrl) {
        hideMessage()
        return triggerFileDownload(fileUrl)
      }

      // if there's no file URL, we're still waiting, update the status
      // with anything new to mention.
      this.setState(() => ({ jobStatus }))
    } catch (err) {
      console.warn(err)
      const errorConfig = {
        uid: `${uid}-error`,
        title: 'Error generating the report',
        autoDismiss: 0,
        children: err.message || 'Uncaught Error!',
      }
      error(errorConfig)
      hideMessage()
    }
  }

  displayWarning = message => {
    const {
      uid,
      warning,
    } = this.props

    const warningConfig = {
      // generate unique UID so we can display multiple messages if necessary
      uid: `${uid}-warning-${Date.now()}`,
      title: 'Warning generating the report',
      autoDismiss: 0,
      children: message,
    }

    warning(warningConfig)
  }

  hideMessage = () => {
    clearInterval(this.__intervalId)
    this.__intervalId = null

    const {
      hide,
      uid,
    } = this.props
    return hide(uid)
  }

  render () {
    return (
      <p className={'padding-bottom-1'}>
        {this.state.jobStatus}
      </p>
    )
  }
}

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    error,
    hide,
    warning,
  }, dispatch)
)

export default connect(
  () => ({}),
  mapDispatchToProps
)(GeneratingMessage)
